import React, {Component} from 'react'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import moment from 'moment'
import Status from '../../../../../../elements/Status'
import {Button} from 'antd'
import {Link, withRouter} from 'react-router-dom'
import _ from 'lodash'

const NewContractButton = withRouter(({history}) => {
  return (
    <Button
      type="primary"
      icon={'plus'}
      size={'small'}
      onClick={() => {
        history.push({
          pathname: 'workOrders/new',
        })
      }}>
      New
    </Button>
  )
})

function WorkOrdersList(props) {
  const {list, onEdit, fetch, fetching, employee, member, owner} = props
  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({value, original}) => {
        const memberKey = _.get(original, 'employee.owner', '').replace(
          'members/',
          '',
        )
        const contractKey = _.get(original, 'contract._id', '').replace(
          'labourContracts/',
          '',
        )
        return memberKey ? (
          <Link
            to={{
              pathname: `/people/member/${memberKey}/contracts/${contractKey}/workOrders/${
                original._key
              }/view`,
            }}
            style={{marginLeft: '10px'}}>
            {value}
          </Link>
        ) : (
          value
        )
      },
    },
    {
      Header: 'Title',
      accessor: 'title',
    },
    {
      Header: 'Employee',
      accessor: 'employee.fn',
      hideable: true,
      hideDefault: !!employee,
    },
    {
      Header: 'Contract',
      accessor: 'contract.code',
      hideable: true,
      hideDefault: !!member,
    },
    {
      Header: 'Start Date',
      accessor: 'date.effective',
      Cell: ({value}) => value && moment(value).format('DD MMM YYYY'),
    },
    {
      Header: 'End Date',
      accessor: 'date.expiry',
      Cell: ({value}) => value && moment(value).format('DD MMM YYYY'),
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'Company ',
      accessor: 'company.fn',
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({value}) => <Status value={value} />,
    },
  ]

  const data = !!employee
    ? list.filter(d => employee._id === d.employee._id)
    : list
  return (
    <CustomTable
      CreateButton={() => (owner ? <NewContractButton /> : '')}
      columns={columns}
      data={data}
      fetch={fetch}
      fetching={fetching}
    />
  )
}

WorkOrdersList.propTypes = {}
WorkOrdersList.defaultProps = {}

export default WorkOrdersList
